import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { environment } from '../../../environments/environment';
import { AlertService } from  '../../services/alert.service';
import { User } from '../users/user';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  user: string;
  alertGroups;
  alerts;
  constructor(private alertService: AlertService,
    private userService: UserService) {

    this.user = this.userService.getUser().username;
    if (this.env.show_alerts)
      this.alertService.getAlerts(this.user).subscribe(
        resp => {
          if (resp.length > 0) {
            this.alerts = resp;
            this.alertGroups = new Set(resp.map(alert => alert.groupId))
            this.alertGroups = Array.from(this.alertGroups).map(group => ({ groupId: group, groupDescription: this.getAlerts(group)[0].groupDescription }))
          }
        }
      );
  }

  env = environment;

  ngOnInit(): void {
  }

  getAlerts(groupId) {
    return this.alerts.filter(alert => alert.groupId == groupId);
  }

}
